module.exports = __webpack_public_path__ + "img/banner2_4New.e17bdb0e.jpg";